import { toast } from "react-toastify";

export const errorTostHandler = (err,number) => {
  console.log(number)
  debugger
  const message = err?.response?.data?.message || err?.message;
  if (message !== "Network Error") {
    toast.error(message);
  }
};
